<template>
    <v-container fluid>
        <v-row class="ml-6 mr-6">
            <v-col cols="12" sm="12">
                <v-card>
                    <v-card-title>
                        <v-col cols="12">
                            <v-text-field v-model="search_text" class="input_600 ml-3" label="搜尋" append-icon="mdi-magnify" outlined></v-text-field>
                        </v-col>
                        病歷號碼: {{patient_code}}
                    </v-card-title>
                    <v-data-table :headers="headers" :items="table_data" :search="search_text" class="elevation-1">
                        <template v-slot:item.index="{ item }">
                            {{table_data.findIndex(e=>e.sp_id==item.sp_id)+1}}
                        </template>
                        <template v-slot:item.set="{item}">
                            <v-btn :to="'/question_ans?s='+item.survey_id+'&i='+item.sp_id+'&u='+item.patient_code" :disabled="item.status==0" class="ml-3" color="success">查看</v-btn>
                        </template>
                        <template v-slot:item.created_at="{item}">
                            <!-- {{UTC2ToLocal(item.created_at)}} -->
                            {{item.created_at}}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL

export default {
    data(){
        return {
            search_text: "",
            page: 0,
            push_dialog: false,
            msg: "",

            headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '問卷名稱', align: 'center', value: 'title_overwrite', width: 120},
                {text: '建立時間', align: 'center', value: 'created_at', width: 120},
                {text: '所屬廠商', align: 'center', value: 'vendor_name', width: 100, sortable: false},
                {text: '所屬醫師', align: 'center', value: 'doctor_name', width: 100, sortable: false},
                {text: '操作', align: 'center', value: 'set', width: 60, sortable: false},
            ],
            table_data: [],

            send_data: {
                name: '',
                patient_num: '',
                line_id: '',
                tags: '',
            },
            
            patient_code: localStorage.getItem('patient_code'),
            page: 0,
        }
    },
    created(){
        this.get_patient_data()
    },
    methods:{
        UTC2ToLocal(date) {
            date = new Date(date)
            var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
            var offset = date.getTimezoneOffset() / 60;
            var hours = date.getHours();
            newDate.setHours(hours - offset);

            if(newDate.getMinutes()<10 && newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getMinutes()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":"+newDate.getMinutes()
            else
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":"+newDate.getMinutes()

            return newDate
        },
        get_patient_data(){
            let post_data = {patient_code: this.patient_code}
            axios.post(host_url+'get_patient_data/', post_data)
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    console.log(tmp)   
                    this.table_data = tmp.table_data                 
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "錯誤提示",　check: "我知道了"})
                }
            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
        }
    }
}
</script>

<style lang="scss" scoped>

::v-deep .input_600{
    max-width: 600px;
}

</style>